import type { IElementConfig } from '../../utils/element/types';

import setAttr from '../../general/attr/setAttr';

import * as exElement from '../../utils/element';

// ----------------------------------------------------------------------------

export interface IFormConfig extends IElementConfig {
    action?: string;
    method?: string;
}

// ----------------------------------------------------------------------------

function create(config: IFormConfig = {}): HTMLFormElement {
    // Create element (form)
    const elForm = exElement.create({
        merge: config,
        tag: 'form',
    }) as HTMLFormElement;

    //
    settings(elForm, config);

    //
    return elForm;
}

function settings(element: HTMLFormElement, config?: IFormConfig): void {
    if (config?.action != null) {
        setAttr(element, 'action', config.action);
    }

    if (config?.method != null) {
        setAttr(element, 'method', config.method);
    }
}

// ----------------------------------------------------------------------------

export { create };
